import React from 'react';

import { connect } from 'react-redux';
import { LanguageDropdown } from 'components';
import { fromLang, fromReservation } from 'store/selectors';

const LanguageDropdownContainer = props => <LanguageDropdown {...props} />;

const mapStateToProps = (state) => {
  const options = fromLang.getLanguages(state).map(lang => ({
    label: lang.name,
    value: lang.code,
    className: lang.code,
  }));
  const reservation = fromReservation.getId(state);
  const selected = fromLang.languageSelector(state);
  return {
    options,
    reservation,
    selected,
  };
};

export default connect(mapStateToProps)(LanguageDropdownContainer);



// WEBPACK FOOTER //
// ./src/containers/LanguageDropdown.js